import styled from 'styled-components';

const ModalBody = styled.div`
  position: relative;
  padding: 10px 15px;
`;

export {
  ModalBody,
};
